export const PAGE_SIZE = 20

export const offsetForPage = page => PAGE_SIZE * (page - 1)